import { useTranslation } from 'react-i18next';
import { useAnchorScroll } from '../hooks/useAnchorScroll';

const ServicePage = () => {
    const { t, i18n } = useTranslation();
    
    // Handle anchor links
    useAnchorScroll();

    return (
        <div className="bg-gray-900 text-white" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
            <div className="relative h-96">
                <img 
                    src="/pictures/2-DSC00452.jpg" 
                    alt="Service and Warranty" 
                    className="absolute top-0 left-0 w-full h-full object-cover object-bottom"
                />
                <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 flex items-center justify-center">
                    <h1 className="text-5xl font-extrabold text-white text-shadow">
                        {t('service.title')}
                    </h1>
                </div>
            </div>

            <section className="bg-gray-200 -mt-24">
                <div className="container mx-auto px-4">
                    <div className="flex flex-wrap">
                        <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg text-gray-800">
                                <div className="px-4 py-5 flex-auto">
                                    <h6 className="text-xl font-semibold">{t('service.warranty.title')}</h6>
                                    <p className="mt-2 mb-4 text-gray-600">
                                        {t('service.warranty.description')}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg text-gray-800">
                                <div className="px-4 py-5 flex-auto">
                                    <h6 className="text-xl font-semibold">{t('service.customerService.title')}</h6>
                                    <p className="mt-2 mb-4 text-gray-600">
                                        {t('service.customerService.description')}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="w-full md:w-4/12 px-4 text-center">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg text-gray-800">
                                <div className="px-4 py-5 flex-auto">
                                    <h6 className="text-xl font-semibold">{t('service.repairLab.title')}</h6>
                                    <p className="mt-2 mb-4 text-gray-600">
                                        {t('service.repairLab.description')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="always-here-for-you" className="pb-20 relative block bg-gray-900 pt-20 scroll-mt-20 border-t-4 border-blue-500" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
                <div className="container mx-auto px-4 lg:pt-24 lg:pb-24">
                    <div className="flex flex-wrap text-center justify-center">
                        <div className="w-full lg:w-6/12 px-4">
                            <h2 className="text-4xl font-semibold text-white">
                                {t('service.alwaysHere.title')}
                            </h2>
                            <p className="text-lg leading-relaxed mt-4 mb-4 text-gray-400">
                                {t('service.alwaysHere.description')}
                            </p>
                        </div>
                    </div>
                                         <div className="flex flex-wrap mt-12 justify-center text-lg text-gray-300">
                         <div className="w-full lg:w-4/12 px-4 text-center mb-4 lg:mb-0">
                             <p className="font-bold">{t('service.contact.phone.title')}</p>
                             <p>{t('service.contact.phone.hours')}</p>
                         </div>
                        <div className="w-full lg:w-4/12 px-4 text-center mb-4 lg:mb-0">
                            <p className="font-bold">{t('service.contact.online.title')}</p>
                            <a href="https://wa.me/972503901000" target="_blank" rel="noopener noreferrer" 
                               className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg transition-colors duration-300">
                              {t('service.contact.online.whatsapp')}
                            </a>
                        </div>
                        <div className="w-full lg:w-4/12 px-4 text-center">
                            <p className="font-bold">{t('service.contact.email.title')}</p>
                            <a href="mailto:koliakovcr7@gmail.com" 
                               className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg transition-colors duration-300">
                              koliakovcr7@gmail.com
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ServicePage; 
